import { useEffect, useRef, useState } from 'react';
// import { useTheme } from 'material-ui/core/styles'
import styled from '@emotion/styled';
import {
  Button,
  Skeleton,
  ThemeProvider,
  Box,
  Grid,
  Typography,
  IconButton,
  createTheme,
  TextField,
  InputAdornment,
  Card,
  Paper,
  SvgIcon,
  Select,
  MenuItem,
  useTheme,
  Modal,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import InfoIcon from '@mui/icons-material/Info';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import AddIcon from '@mui/icons-material/Add';
import ChatIcon from '@mui/icons-material/Chat';

import DOMPurify from 'dompurify';
import './KnowledgeChat.css';

import copy from 'copy-to-clipboard';
// import Markdown from 'react-markdown'
// import { ExampleListV2, Example } from "../../components/Example";
import useStreamChat from '../../hooks/KnowledgeAI/useStreamChat';
import PopperOptions from '../../components/KnowledgeAI/ChatOptions';
import useGetProjectsInfo from '../../hooks/KnowledgeAI/useGetProjectsInfo';
import useProjectChat from '../../hooks/KnowledgeAI/useProjectChat';
import useUploadToIndex from '../../hooks/KnowledgeAI/useUploadToIndex';
import useFileUploadChat from '../../hooks/KnowledgeAI/useFileUploadChat';
import AISparkIcon from '../../components/AISparkIcon';
import useGetSessionsInfo from '../../hooks/KnowledgeAI/useFetchSessions';
import useSaveChatSessions from '../../hooks/KnowledgeAI/useSaveChatSessions';
import useSaveChatFeedback from '../../hooks/KnowledgeAI/useSaveChatFeedback';
import Loader from '../../components/KnowledgeAI/Loader';
import SummaryModal from '../../components/KnowledgeAI/SummaryModal';
import CitationsModal from '../../components/KnowledgeAI/CitationsModal';
import TranscriptSummaryModal from '../../components/KnowledgeAI/TranscriptSummaryModal';
// import { te, tr } from "date-fns/locale";
import useGetSessionChat from '../../hooks/KnowledgeAI/useSessionChat';
import { Link, useParams, useNavigate } from 'react-router-dom';
// import { set } from "lodash";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Tooltip } from '@mui/material';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
// import CloseIcon from '@mui/icons-material/Close';
import MicIcon from '@mui/icons-material/Mic';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import styles from '../../components/QuestionInput/QuestionInput.module.css';
import { useDispatch, useSelector } from 'react-redux';
import uploadHandler from '../../components/KnowledgeAI/fileUploadHandler';
import VoiceComponent from '../../components/voice/VoiceComponent';
import QuotaAlert from '../../components/KnowledgeAI/QuotaAlert';
import QuotaExceededDialog from '../../components/KnowledgeAI/QuotaExceededDialog';
import PIIWarningDialog from '../../components/KnowledgeAI/PIIWarningDialog';
import { AnswerError } from '../../components/Answer/AnswerError';
import { UserChatMessage } from '../../components/UserChatMessage/UserChatMessage';
import ls from 'localstorage-slim';
import { Field, makeStyles, ProgressBar, Spinner } from '@fluentui/react-components';
import { color } from 'framer-motion';
import LinearProgress from '@mui/material/LinearProgress';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import FeedBackPopup from './FeedBackPopup';
import { Toast } from 'primereact/toast';
// import SpeechConvert from "../../components/speech/speech";
// import { QuestionInput } from "../../components/QuestionInput";

const StyledTextField = styled(TextField)({
  '&. MuiTouchRipple-root': {
    display: 'none',
  },
});

const StyledButton = styled(Button)({
  // fontFamily: "segoeui",
  lineHeight: 1,
  mt: '10px',
  mb: '10px',
  p: '16px 10px',

  borderRadius: '4px',
  // border: " 1.5px solid",
  width: '100%',
  height: '2rem',

  // "&:hover": {
  //   backgroundColor: "#fff",
  //   color: "#2962FF",
  // },
  '&.MuiButton-root': {
    padding: '16px 16px',
  },
});

const HighlightOnHover = styled('div')({
  '&:hover .highlightIcon': {
    position: 'relative',
    boxShadow: '0 0 10px 5px rgba(169, 169, 169, 0.7)',
    borderRadius: '5px',
    zIndex: '1',
    transition: 'box-shadow 0.3s ease-in-out',
  },
});

const GridBoxes = styled(Grid)({
  borderRadius: '4px',
});

const StyledTypography = styled(Typography)({
  // fontFamily: "segoeui",
  // color: "rgba(34, 34, 34, 1)",
  lineHeight: '2',
});

const StyledPaper = styled(Paper)({
  padding: '14px',
});

const ChatBox = styled(Box)({
  width: '100%',
  padding: '0px 24px 0px 24px',
});

const useStyles = makeStyles({
  container: {
    // @ts-ignore
    margin: '20px 0px',
    color: 'blue',
  },
});

const KnowledgeChat = (props?: any) => {
  const progress_styles = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);

  const { sessionId } = useParams();
  const SearchBarTheme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            padding: '10px',
            borderRadius: '6px',
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`,
          },
          input: {
            paddingLeft: '10px',
            paddingRight: '10px',
          },
        },
      },
    },
  });

  const { data: projectsInfo, loading: projectsInfoLoading } = useGetProjectsInfo();
  const {
    smartStreamChat,
    data: streamChatData,
    loading: streamChatLoading,
    tokenInfo,
    piiInfo,
    piiEntities,
    tokenBreakdown,
  } = useStreamChat();
  const { projectChat, data: projectChatData, loading: projectChatLoading } = useProjectChat();
  const { data: indexedData, setData: setIndexedData, loading: indexLoading, indexFiles } = useUploadToIndex();
  const { fileUploadChat, data: fileUploadData, loading: fileUploadLoading } = useFileUploadChat();

  const {
    data: sessionHistoryData,
    loading: sessionHistoryLoading,
    fetchSessionsInfo: fetchSessionHistory,
  } = useGetSessionsInfo();
  const { data: sessionChatsData, loading: sessionChatLoading, fetchSessionChat } = useGetSessionChat();
  const { data: savedChatRes, loading: isChatSaved, saveSessionsInfo: saveChat } = useSaveChatSessions();
  const { data: savedFeedbackRes, loading: isFeedbackSaved, saveFeedbackInfo: saveFeedback } = useSaveChatFeedback();

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [trnscriptModalOpen, setTranscriptModalOpen] = useState<boolean>(false);
  const defaultModel = process.env.REACT_APP_DEFAULT_MODEL || 'GPT4O_GLOBAL';
  const [chatMode, setChatMode] = useState(defaultModel);
  const [selectedApproach, setSelectedApproach] = useState<string>(process.env.DEFAULT_APPROACH || 'gpt-5.2');
  const [chatHistory, setChatHistory]: any[] = useState([]);
  const [textValue, setTextValue] = useState('');
  const [fileName, setFileName] = useState<any>([]);
  const [project, setProject] = useState<any>(null);
  // const [isIndexSuccess, setIsIndexSuccess] = useState<boolean>(true);
  const [isIndexLoading, setIsIndexLoading] = useState<boolean>(false);
  const [sessionIdL, setSessionIdL] = useState<number>(0);
  const [chatSessionList, setChatSessionList] = useState<any[]>([]);
  const [chatOption, setChatOption] = useState<'none' | 'youtube' | 'file' | 'project'>('none');
  const [selectedSession, setSelectedSession] = useState<number>(0);
  const [citationModalOpen, setCitationModalOpen] = useState<boolean>(false);
  const [citationURL, setCitationURL] = useState<any>();
  const [followUpQuestions, setFollowUpQuestions] = useState<any[]>([]);
  const [chatError, setChatError] = useState<unknown>(false);
  const [chatSaved, setChatSaved] = useState(true);

  const [uploadedImage, setUploadedImage] = useState<string | null>(null);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const { transcript, resetTranscript, listening } = useSpeechRecognition();
  const [question, setQuestion] = useState<string>('');
  const sendQuestionDisabled = !question.trim();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const [transcriptData, setTranscriptData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [conversationLength, setConversationLength] = useState(0);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const enableVoice = process.env.REACT_APP_ENABLE_VOICE || 'true';
  const Voiceprojects = process.env.REACT_APP_VOICE_PROJECTS || 'credit-org-index'.split(',');
  interface ChatMessage {
    ChatQuery: string;
    ChatResponse: string;
  }

  const [lastMessage, setLastMessage] = useState<ChatMessage | null>(null);
  const [feedbackPopupOpen, setFeedbackPopupOpen] = useState<boolean>(false);
  const [quotaExceededOpen, setQuotaExceededOpen] = useState<boolean>(false);
  const [quotaExceededMessage, setQuotaExceededMessage] = useState<string>('');
  const [piiWarningOpen, setPiiWarningOpen] = useState<boolean>(false);
  const [piiWarningMessage, setPiiWarningMessage] = useState<string>('');
  const [likeDislikeStates, setLikeDislikeStates] = useState<Record<number, { liked: boolean; disliked: boolean }>>({});
  const [disableLikeDislike, setDisableLikeDislike] = useState<boolean>(false);
  const [lastDate, setLastDate] = useState<Date | null>(null);

  // //@ts-ignore
  // const transcriptData  = useSelector((state) => state.SpeechToText.transcript);
  // // setTranscriptData(transcriptData);
  // console.log(`transcriptData: ${transcriptData}`);
  // const [combinedMessages, setCombinedMessages] = useState([]);
  // const [typedMessage, setTypedMessage] = useState("");
  // const [prevTranscriptLength, setPrevTranscriptLength] = useState(transcriptData.length);

  const showSuccess = (text: string) => {
    toast.current?.show({ severity: 'success', summary: 'Success', detail: text, life: 3000 });
  };

  const showInfo = (text: string) => {
    toast.current?.show({ severity: 'info', summary: 'Info', detail: text, life: 3000 });
  };

  const showError = (text: string) => {
    toast.current?.show({ severity: 'error', summary: 'Error', detail: text, life: 3000 });
  };
  const handleStartListening = () => {
    SpeechRecognition.startListening();
    setQuestion('');
  };

  const handleStopListening = () => {
    SpeechRecognition.stopListening();
    setQuestion(transcript);
  };

  const handleIconClick = () => {
    imageInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      setUploadedFile(selectedFile);
      setUploadedImage(null);
    }
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile);
      setUploadedImage(imageUrl);
    }
  };

  const gpt4 = {
    approach: 'gpt432K',
    model: 'gpt-4-32k',
    deployment: 'gpt432K',
  };

  const gpt3 = {
    approach: 'gpt3516K',
    model: 'gpt-3.5-turbo',
    deployment: 'gpt3516K',
  };

  const modelMap: any = {
    Claude: {
      name: 'Claude 3 Sonnet',
      model: 'anthropic.claude-3-sonnet-20240229-v1:0',
    },
    Titan: {
      name: 'Titan Express',
      model: 'amazon.titan-text-express-v1',
    },
  };

  // Track how many valid chunks we've already processed to avoid duplication
  const processedChunksRef = useRef(0);

  const updateChatHistory = (chunkData: any) => {
    try {
      // Split and filter out empty lines to get only valid JSON chunks
      const chatHistoryArray = chunkData.split('\n').filter((line: string) => line.trim() !== '');
      // const enablespeak = process.env.REACT_APP_SPEAK || true

      // Only process NEW chunks that we haven't seen before
      const newChunks = chatHistoryArray.slice(processedChunksRef.current);

      newChunks.forEach((element: any, index: number) => {
        try {
          const chatHistoryObject = JSON.parse(element);
          const content = chatHistoryObject?.choices[0]?.delta?.content;
          if (content !== null && content !== undefined && content !== '') {
            // if(enablespeak){handleSpeak(stripHtmlTags(content))}
            const lastChatHistory = chatHistory[0];
            lastChatHistory.ChatResponse += chatHistoryObject?.choices[0]?.delta?.content;
            setChatHistory([lastChatHistory, ...chatHistory.slice(1, chatHistory.length)]);
          }
        } catch (err) {
          console.log(err);
        }
      });

      // Update the count of valid processed chunks (after filtering empty lines)
      processedChunksRef.current = chatHistoryArray.length;

      // Handle followup questions from the LAST chunk
      try {
        if (chatHistoryArray[chatHistoryArray.length - 1] === '') {
          chatHistoryArray.pop();
        }
        // console.log("lastestChatHistory", chatHistoryArray[chatHistoryArray.length - 1]);
        if (chatHistoryArray.length > 0) {
          const lastestChatHistory = JSON.parse(chatHistoryArray[chatHistoryArray.length - 1]);
          if (lastestChatHistory?.choices[0]?.context?.followup_questions) {
            setFollowUpQuestions(lastestChatHistory?.choices[0]?.context?.followup_questions);
          } else {
            setFollowUpQuestions([]);
          }
        } else {
          setFollowUpQuestions([]);
        }
      } catch (err) {
        console.error(err);
        console.log('Failed to parse chat history');
      }
    } catch (e) {
      console.log(e);
      setChatError(e);
    }
  };

  useEffect(() => {
    try {
      if (chatHistory.length > 0 && streamChatLoading === false && streamChatData && chatHistory[0]?.ChatResponse) {
        const user_data = ls.get('token-gpt-app');
        //@ts-ignore
        const username = user_data.email.split('@')[0];
        const latestDate = new Date();
        const saveChatReq = {
          app: process.env.REACT_APP_APP_NAME || 'pmr',
          project_name: project,
          username: username,
          session_id: Number(selectedSession === 0 ? sessionIdL + 1 : selectedSession),
          session_name:
            selectedSession === 0 ? chatHistory[0]?.ChatQuery?.slice(0, 100) : chatHistory[0]?.ChatQuery?.slice(0, 100),
          role: 'user',
          timestamp: latestDate?.toISOString(),
          conversation: JSON.stringify({
            user_query: chatHistory[0]?.ChatQuery,
            bot: chatHistory[0]?.ChatResponse || '',
          }),
          response_object: {},
          request_object: {},
          scope: 'quick-chat',
          chat_type: isGeneralChat ? 'general' : 'rag',
          model: selectedApproach,
          prompt_tokens: tokenInfo?.prompt_tokens ?? 0,
          completion_tokens: tokenInfo?.completion_tokens ?? 0,
          pii_entities: piiEntities,
          token_breakdown: tokenBreakdown,
        };
        if (!chatSaved) {
          saveChat(saveChatReq);
          setLastDate(latestDate);
          setChatSaved(true);
        }

        if (chatHistory.length === 1 && selectedSession === 0) {
          setChatSessionList([
            { session_id: sessionIdL + 1, session_name: chatHistory[0]?.ChatQuery?.slice(0, 100) },
            ...chatSessionList,
          ]);
          setSelectedSession(sessionIdL + 1);
          setSessionIdL(sessionIdL + 1);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [streamChatLoading, chatHistory]);

  // Update chat history when new data is received
  useEffect(() => {
    if (streamChatData) {
      if (streamChatData?.status_code === 429 && streamChatData?.error === 'quota_exceeded') {
        setQuotaExceededMessage(streamChatData.message || 'Token limit exceeded');
        setQuotaExceededOpen(true);
        setChatHistory((prev: any[]) => prev.slice(1)); // remove the pending empty response
        return;
      }
      updateChatHistory(streamChatData);
    }
  }, [streamChatData]);

  // Show PII warning when backend detects PII in the message
  useEffect(() => {
    if (piiInfo?.detected) {
      setPiiWarningMessage(piiInfo.message);
      setPiiWarningOpen(true);
    }
  }, [piiInfo]);
  const userdata = ls.get('token-gpt-app');
  //@ts-ignore
  const email = userdata.email.split('@')[0];
  const isGeneralChat = project?.IndexName === 'General-chat';

  // Reset selectedApproach based on isGeneralChat
  useEffect(() => {
    if (isGeneralChat) {
      setSelectedApproach('gpt-4.1');
    } else {
      setSelectedApproach(process.env.DEFAULT_APPROACH || 'gpt-5.2');
    }
  }, [isGeneralChat]);

  // Fetch session history on page load and whenever isGeneralChat changes
  useEffect(() => {
    fetchSessionHistory({
      username: email,
      app_name: 'pmr',
      retrieve_type: isGeneralChat ? 'db' : 'table',
      fetch_all: 'true',
      general_chat: isGeneralChat ? 'true' : 'false',
    });

    // if (transcriptData.length > prevTranscriptLength) {
    //     const newTranscripts = transcriptData.slice(prevTranscriptLength);
    //     const newCombinedMessages = [
    //       ...combinedMessages,
    //       ...newTranscripts.map((msg) => ({ type: "borrower", text: msg })),
    //     ];
    //     setCombinedMessages(newCombinedMessages);
    //     setPrevTranscriptLength(transcriptData.length);
    //   }
    // }, [transcriptData, prevTranscriptLength, combinedMessages]);
  }, [isGeneralChat]);

  // Update chat session list when new data is received
  useEffect(() => {
    const sessionHistory = sessionHistoryData?.chat_history;
    // console.log(sessionHistoryLoading);
    if (sessionHistoryLoading === false) {
      if (sessionHistory === undefined || sessionHistory === null || sessionHistory.length === 0) {
        // API returned empty — clear the session list
        setChatSessionList([]);
        return;
      }

      console.log('sessionHistory Inside');
      const currentTimestamp = Date.now();

      // Create a map to store the unique session_id objects
      const sessionMap = new Map();

      sessionHistory.forEach(
        (session: { session_name: any; session_id: any; createtimestamp: string | number | Date }) => {
          const sessionId = session.session_id;
          const sessionTimestamp = new Date(session.createtimestamp).getTime();

          // Check if this session_id is already in the map
          if (sessionMap.has(sessionId)) {
            const existingSession = sessionMap.get(sessionId);
            const existingTimestamp = new Date(existingSession.createtimestamp).getTime();

            // Calculate the absolute difference in timestamps
            const currentDifference = Math.abs(currentTimestamp - sessionTimestamp);
            const existingDifference = Math.abs(currentTimestamp - existingTimestamp);

            // Replace if the new session is closer to the current timestamp
            if (currentDifference < existingDifference) {
              sessionMap.set(sessionId, session);
            }
          } else {
            // If session_id is not in the map, add it
            sessionMap.set(sessionId, session);
          }
        }
      );

      // Convert the map values to an array
      // return Array.from(sessionMap.values

      // Find the session with the longest distance from the current timestamp
      let maxDistanceSession = null;
      let maxDistance = 0;

      sessionHistory.forEach(
        (session: { session_name: any; session_id: string; createtimestamp: string | number | Date }) => {
          const sessionTimestamp = new Date(session.createtimestamp).getTime();
          const distance = Math.abs(currentTimestamp - sessionTimestamp);
          const sessionID = parseInt(session.session_id);
          if (distance > maxDistance) {
            sessionMap.set(session.session_id, {
              session_id: session.session_id,
              session_name: session.session_name,
              createtimestamp: sessionMap.get(session.session_id)?.createtimestamp,
            });
          }
          setSessionIdL((prevSessionIdL) => {
            if (prevSessionIdL < sessionID) {
              return sessionID;
            } else {
              return prevSessionIdL;
            }
          });
        }
      );

      // Sort the result array by createTimestamp
      const resultArray = Array.from(sessionMap.values());
      resultArray.sort((a, b) => new Date(b.createtimestamp).getTime() - new Date(a.createtimestamp).getTime());
      // console.log('resultArray: ', resultArray);
      setChatSessionList(resultArray);
    }
  }, [sessionHistoryLoading]);

  useEffect(() => {
    try {
      setChatHistory([]);
      const sessionChats = sessionChatsData?.chat_history;
      if (
        sessionChatLoading === false &&
        sessionChats !== undefined &&
        sessionChats !== null &&
        sessionChats.length > 0
      ) {
        let tempSessionChat = sessionChats.map((sessionConv: any) => {
          const conversation = JSON.parse(sessionConv.conversation);
          if (conversation.user_query !== '' && conversation.bot !== '')
            setChatHistory((prevValue: any) => [
              ...prevValue,
              { ChatQuery: conversation.user_query, ChatResponse: conversation.bot },
            ]);
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [sessionChatLoading]);

  const handleProjectsChatStream = async (projectId: number) => {
    const newProjectId = projectsInfo?.find((x: any) => x.ID === projectId);
    if (newProjectId === undefined) {
      setChatOption('none');
      return;
    }
    setSelectedSession(0);
    setChatOption('project');
    setProject(newProjectId);
    setChatHistory([]);
  };

  const scrollIntoView = (element: any) => {
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  const onTextFieldChange = (event: any) => {
    setQuestion(event.target.value);
    setTranscriptData(event.target.value);
  };

  const handleSendChat = async (textString?: string, retry?: boolean, filePath?: string | null) => {
    try {
      setLikeDislikeStates({});
      setDisableLikeDislike(false);
      setChatSaved(false);
      cancelSpeak();
      setIsSpeaking(false);
      chatError && setChatError(undefined);

      // Reset processed chunks counter for new chat
      processedChunksRef.current = 0;

      if (textValue === '' && !textString) {
        return;
      }
      const tempText = textString ? textString : textValue;
      setQuestion(tempText);
      const chatHistoryArray = [...chatHistory];
      console.log('Retry: ', retry);
      if (!retry) {
        setChatHistory([{ ChatQuery: tempText, ChatResponse: '' }, ...chatHistory]);
      }
      setTextValue('');

      // console.log('projectInfo: ', projectsInfo);
      // console.log('project: ', project.SourcePage);
      // const selectedProjectInfo = projectsInfo?.find((x: any) => x.ProjectName == project);
      // console.log('newProjectId: ', selectedProjectInfo);
      const user_data = ls.get('token-gpt-app');
      //@ts-ignore
      const username = user_data.email.split('@')[0];
      //@ts-ignore
      const userEmail = user_data.email;
      if (chatOption === 'project') {
        await smartStreamChat(
          // chatOption,
          username,
          project.SourcePage,
          [
            ...chatHistoryArray.reverse().map((x: any) => {
              return {
                user: x.ChatQuery,
                bot: x.ChatResponse,
              };
            }),
            {
              user: tempText,
            },
          ],
          project.IndexName,
          project.PromptPrefix,
          selectedApproach,
          filePath,
          userEmail
        );
        //navigate(`/dashboard/chat/${selectedSession === 0 ? sessionIdL + 1 : selectedSession}`)
      } else {
        await smartStreamChat(
          username,
          // chatOption,
          project.SourcePage,
          [
            ...chatHistoryArray.reverse().map((x: any) => {
              return {
                user: x.ChatQuery,
                bot: x.ChatResponse,
              };
            }),
            {
              user: tempText,
            },
          ],
          project.IndexName,
          project.PromptPrefix,
          selectedApproach,
          filePath,
          userEmail
        );
        //navigate(`/dashboard/chat/${selectedSession === 0 ? sessionIdL + 1 : selectedSession}`)
      }
      //else if (chatOption === "project") {
      //     await projectChat(
      //         project.Username,
      //         project.SourcePage,
      //         [
      //             ...chatHistoryArray.reverse().map((x: any) => {
      //                 return {
      //                     user: x.ChatQuery,
      //                     bot: x.ChatResponse,
      //                 };
      //             }
      //             ),
      //             {
      //                 user: tempText,
      //             },
      //         ],
      //         chatMode,
      //         project.IndexName,
      //         project.PromptPrefix
      //     );
      // }
    } catch (e) {
      console.log('error: ', e);
      setChatError(e);
    }
  };

  const handleSessionClick = (session_id: number) => {
    setLikeDislikeStates({});
    setDisableLikeDislike(true);
    setChatSaved(true);
    const user_data = ls.get('token-gpt-app');
    //@ts-ignore
    const username = user_data.email.split('@')[0];
    fetchSessionChat({
      retrieve_type: isGeneralChat ? 'db' : 'table',
      app_name: 'pmr',
      username: username,
      session_id: session_id,
      general_chat: isGeneralChat ? 'true' : 'false',
    });
    setSelectedSession(session_id);
  };

  useEffect(() => {
    if (sessionId) {
      if (sessionId === '0') {
        setSelectedSession(0);
        setChatOption('none');
        setChatHistory([]);
      } else {
        fetchSessionChat({
          username: email,
          app_name: process.env.REACT_APP_APP_NAME || 'kai',
          retrieve_type: isGeneralChat ? 'db' : 'table',
          session_id: sessionId,
          general_chat: isGeneralChat ? 'true' : 'false',
        });
        setSelectedSession(parseInt(sessionId));
      }
    }
  }, [sessionId, isGeneralChat]);

  const setCitationLink = (citationLink: string) => {
    setCitationURL(citationLink);
    setCitationModalOpen(true);
  };

  const stripHtmlTags = (html: string) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  const analyzeConversations = async () => {
    try {
      setLoader(true);
      if (
        (transcriptData === null ||
          transcriptData === undefined ||
          conversationLength === 0 ||
          conversationLength !== chatHistory.length) &&
        chatHistory.length > 0
      ) {
        setConversationLength(chatHistory.length);
        const url = process.env.REACT_APP_ANALYZE_CONV_API || '';
        var conversations: any = [];
        chatHistory.map((chat: any) => {
          conversations.push({
            speaker: 'user',
            content: chat.ChatQuery,
          });
          // conversations.push({
          //     "speaker": "bot",
          //     "content": chat.ChatResponse
          // })
          const maxLength = 29000000; // Set the maximum length for each chunk
          const chatResponse = stripHtmlTags(chat.ChatResponse);

          // Break the chatResponse into chunks if it exceeds maxLength
          if (chatResponse.length > maxLength) {
            const chunks = [];
            for (let i = 0; i < chatResponse.length; i += maxLength) {
              chunks.push(chatResponse.substring(i, i + maxLength));
            }

            // Push each chunk as a separate conversation entry
            chunks.forEach((chunk) => {
              // conversations.push({
              //     "speaker": "user",
              //     "content": chat.ChatQuery
              // });
              conversations.push({
                speaker: 'bot',
                content: 'continuation to previous response: ' + chunk,
              });
            });
          } else {
            // If chatResponse is within the limit, push it directly
            conversations.push({
              speaker: 'bot',
              content: chatResponse,
            });
          }
        });
        await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            conversations: conversations,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            setTranscriptData(data);
            setTranscriptModalOpen(true);
          })
          .catch((err) => {
            console.log(err);
            setChatError(err);
          });
      } else {
        setTranscriptModalOpen(true);
      }
    } catch (e) {
      console.log(e);
      setChatError(e);
      setLoader(false);
    }
    setLoader(false);
  };

  const handleDislike = (index: number, message: any) => {
    setFeedbackPopupOpen(true); // Open the feedback popup
    setLikeDislikeStates((prev) => ({
      ...prev,
      [index]: {
        liked: false,
        disliked: true,
      },
    }));
  };

  const handleLike = async (index: number) => {
    setLikeDislikeStates((prev) => ({
      ...prev,
      [index]: {
        liked: !prev[index]?.liked,
        disliked: false,
      },
    }));
    try {
      const user_data = ls.get('token-gpt-app');
      //@ts-ignore
      const username = user_data.email.split('@')[0];
      const saveChatReq = {
        app: process.env.REACT_APP_APP_NAME || 'pmr',
        project_name: project,
        username: username,
        session_id: selectedSession,
        bot: lastMessage ? lastMessage.ChatResponse : '',
        session_name:
          selectedSession === 0 ? chatHistory[0]?.ChatQuery?.slice(0, 100) : chatHistory[0]?.ChatQuery?.slice(0, 100),
        role: 'user',
        timestamp: lastDate?.toISOString(),
        conversation: JSON.stringify({
          user_query: chatHistory[0]?.ChatQuery,
          bot: chatHistory[0]?.ChatResponse ?? '',
        }),
        response_object: {},
        request_object: {},
        scope: 'quick-chat',
        feedback_type: 'Good',
        feedback_message: 'Good',
      };
      saveFeedback(saveChatReq);
      showSuccess('Feedback submitted successfully!');
      setDisableLikeDislike(true);
    } catch (error) {
      console.error('Error submitting like feedback:', error);
      showError('Error submitting feedback. Please try again.');
    }
  };

  const handleFeedbackClose = () => {
    setFeedbackPopupOpen(false); // Close the popup without submission
  };
  const handleFeedbackSubmit = async (feedback: { type: string; message: string }) => {
    try {
      // Prepare the API request payload
      const user_data = ls.get('token-gpt-app');
      //@ts-ignore
      const username = user_data.email.split('@')[0];
      const saveChatReq = {
        app: process.env.REACT_APP_APP_NAME || 'pmr',
        project_name: project,
        username: username,
        session_id: selectedSession,
        bot: lastMessage ? lastMessage.ChatResponse : '',
        session_name:
          selectedSession === 0 ? chatHistory[0]?.ChatQuery?.slice(0, 100) : chatHistory[0]?.ChatQuery?.slice(0, 100),
        role: 'user',
        timestamp: lastDate?.toISOString(),
        conversation: JSON.stringify({
          user_query: chatHistory[0].ChatQuery,
          bot: chatHistory[0].ChatResponse ?? '',
        }),
        response_object: {},
        request_object: {},
        scope: 'quick-chat',
        feedback_type: feedback.type,
        feedback_message: feedback.message,
      };
      saveFeedback(saveChatReq);
      showSuccess('Feedback submitted successfully!');
      setDisableLikeDislike(true);
      // const payload = {

      //     sessionID: selectedSession,
      //     query_text: "sample query",
      //     response_text:"sample response",
      //     feedback_type: feedback.type,
      //     feedback_message: feedback.message
      // };

      // console.log("Submitting Feedback:", payload);

      // // Make the API call
      // const response = await fetch(process.env.REACT_APP_FEEDBACK_API_URL || "https://func-dev-kai-utils-prmi.azurewebsites.net/api/save_feedback?code=ckBs8S9l3GtAvYL0xTEXzWW-UeKBRx3Af62iZOtG9BvoAzFuLraYGA==", {
      //     method: "POST",
      //     headers: {
      //         "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify(payload),
      // });

      // Handle the response
      // if (response.ok) {
      //     const responseData = await response.json();
      //     console.log("Feedback submitted successfully:", responseData);
      //     alert("Feedback submitted successfully!");
      // } else {
      //     console.error("Failed to submit feedback:", response.statusText);
      //     alert("Failed to submit feedback. Please try again.");
      // }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      showError('Error submitting feedback. Please try again.');
      setDisableLikeDislike(false);
      alert(error);
    } finally {
      // Close the feedback popup

      setFeedbackPopupOpen(false);
    }
  };

  const ChatComponent = ({ message, index, setCitationLink, liked, disliked, onLike, onDislike }: any) => {
    // handleSpeak(stripHtmlTags(message.ChatResponse));
    // cancelSpeak()
    setLastMessage(message);
    // console.log(lastMessage, "lastMessage");
    // console.log(message, "Message to be liked or disliked");
    // const [liked, setLiked] = useState<boolean>(false);
    // const [disliked, setDisliked] = useState<boolean>(false);
    const [isLikeDislike, setIsLikeDislike] = useState<boolean>(false);
    // const [feedbackPopupOpen, setFeedbackPopupOpen] = useState<boolean>(false);
    const [copied, setCopied] = useState<boolean>(false);
    const [customSpeak, setCustomSpeak] = useState(false);
    message.ChatResponse = message.ChatResponse.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(
      /\#\#\#(.*?)/g,
      '<strong>$1</strong>'
    );
    const responseLines = message.ChatResponse ? message.ChatResponse.split(/\[(.*?)\]/) : '';
    const pdfCitations = message.ChatResponse ? responseLines.filter((line: any) => line.match(/\.pdf/)) : '';
    // console.log(pdfCitations, "pdfCitations");
    function replaceOccurrences(inputString: string) {
      const occurrences: any = {};
      let counter = 1;
      const modifiedString = inputString.replace(/\[(.*?)\]/g, (match, group) => {
        if (!occurrences[group]) {
          occurrences[group] = counter++;
        }
        return `[${occurrences[group]}]`;
      });
      // const modifiedString = inputString;
      const uniqueOccurrences = Object.keys(occurrences);

      return { modifiedString, uniqueOccurrences };
    }
    const { modifiedString, uniqueOccurrences } = replaceOccurrences(message.ChatResponse);
    // console.log('Modified String: ', modifiedString);
    const getCitationFilePath = (citation: string): string => {
      const url = process.env.REACT_APP_CITATION_URL || '';
      const storageAccount = process.env.REACT_APP_STORAGE_ACCOUNT || '';
      // file_name must be the LAST param — matches old working pattern from PMR-Prod-Phase2
      // where file_name= was appended at end so encodeURIComponent result has no trailing params
      return `${url}&storage_account=${storageAccount}&container=content&file_name=${encodeURIComponent(citation)}`;
    };

    // const [activeCitation, setActiveCitation] = useState<string>();

    const customSpeech = (text: string) => {
      text = text.replace(/\[(.*?)\]/g, '');
      const synth = window.speechSynthesis;
      if (customSpeak) {
        synth.cancel();
        setCustomSpeak(false);
      } else {
        if ('speechSynthesis' in window) {
          setCustomSpeak(true);
          synth.cancel();
          const voices = synth.getVoices();
          const utterance = new SpeechSynthesisUtterance(text);
          const voice_index = Number(process.env.REACT_APP_VOICE_INDEX) || 112;
          utterance.voice = voices[voice_index];
          synth.speak(utterance);
          utterance.onend = () => {
            setCustomSpeak(false);
          };
        } else {
          alert('Sorry, your browser does not support speech synthesis.');
        }
      }
    };

    useEffect(() => {
      if (
        enableVoice == 'true' &&
        Voiceprojects.includes(project?.IndexName) &&
        !streamChatLoading &&
        !citationModalOpen &&
        !loader &&
        !trnscriptModalOpen
      ) {
        if (index === 0) customSpeech(stripHtmlTags(message.ChatResponse));
      }
    }, [streamChatLoading]);

    const handleCitationClick = (citation: string) => {
      setCitationLink(citation);
      console.log('clicked on citations');
    };

    return (
      <Box
        width="100%"
        display="flex"
        paddingTop="10px"
        key={index}
        borderRadius="15px"
        flexDirection="column"
        mb="10px"
        // px="32px"
        // pt="24px"
        gap="10px"
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'flex-start',
          }}
        >
          <SvgIcon
            sx={{
              marginTop: '10px',
              fontSize: '32px',
              // color: "#245894",
            }}
          >
            <AccountCircleIcon />
          </SvgIcon>
          <StyledPaper elevation={2}>
            <StyledTypography
              variant="body1"
              sx={{
                width: '100%',
              }}
            >
              {message.ChatQuery}
            </StyledTypography>
          </StyledPaper>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <SvgIcon
            sx={{
              marginTop: '10px',
              fontSize: '32px',
              // color: "#245894",
            }}
          >
            <AISparkIcon />
          </SvgIcon>

          {message.ChatResponse ? (
            <StyledPaper
              elevation={2}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                backgroundColor:
                  message.ChatResponse === 'Something went wrong!'
                    ? 'rgba(255,0,0,0.1)'
                    : theme.palette.background.paper,
              }}
            >
              <StyledTypography
                variant="body1"
                // fontWeight="400"
                sx={{
                  width: '100%',
                }}
              >
                {message.ChatResponse ? (
                  <>
                    <Box>
                      <Grid
                        container
                        direction="row"
                        justifyContent="flex-end"
                        // gap={1}
                      >
                        {enableVoice == 'true' && Voiceprojects.includes(project?.IndexName) ? (
                          <Grid item>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                customSpeech(stripHtmlTags(message.ChatResponse));
                              }}
                            >
                              <Tooltip title={customSpeak ? 'Mute' : 'Speak'}>
                                {!customSpeak ? <VolumeOffIcon /> : <VolumeUpIcon />}
                              </Tooltip>
                            </IconButton>
                          </Grid>
                        ) : null}
                        {/* <Grid item>
                                                <IconButton color="primary">
                                                    <Tooltip title="Analyze Conversation">
                                                        <InfoIcon onClick = {()=>analyzeConversations()} />
                                                    </Tooltip>
                                                </IconButton>
                                         </Grid> */}
                      </Grid>
                    </Box>
                    <div
                      className="answerText"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(modifiedString),
                      }}
                    ></div>
                    {/* <ReactMarkdown>{modifiedString}</ReactMarkdown> */}

                    {!!uniqueOccurrences.length && !isGeneralChat && (
                      <Box sx={{ mb: '30px' }}>
                        <Box>
                          <span className="citationLearnMore">Citations:</span>
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              gap: '10px',
                              flexWrap: 'wrap',
                            }}
                          >
                            {uniqueOccurrences.map((x: string, i: number) => {
                              const path = getCitationFilePath(x);
                              return (
                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                <a
                                  key={i}
                                  className="citation"
                                  title={x}
                                  onClick={() => {
                                    handleCitationClick(path);
                                  }}
                                  target="_blank"
                                  download
                                  // href={activeCitation}
                                  rel="noreferrer"
                                >
                                  {i + 1}:{`${x}`}
                                </a>
                              );
                            })}
                          </Box>
                        </Box>
                      </Box>
                    )}
                    {message.ChatResponse !== 'Something went wrong!' && typeof index === 'number' && index === 0 && (
                      <Box>
                        <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          // gap={1}
                        >
                          <Grid item>
                            {!disliked && (
                              <IconButton color="primary" disabled={disableLikeDislike} onClick={onLike}>
                                {liked ? <ThumbUpIcon fontSize="small" /> : <ThumbUpOutlinedIcon fontSize="small" />}
                              </IconButton>
                            )}
                          </Grid>
                          <Grid item>
                            <IconButton color="primary" onClick={onDislike} disabled={disableLikeDislike}>
                              {disliked ? (
                                <ThumbDownIcon fontSize="small" />
                              ) : (
                                <ThumbDownOutlinedIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Grid>
                          <Grid item>
                            <IconButton color="primary">
                              {copied ? (
                                <LibraryAddCheckIcon fontSize="small" />
                              ) : (
                                <CopyAllIcon
                                  fontSize="small"
                                  onClick={() => {
                                    copy(message.ChatResponse);
                                    setCopied(true);
                                    setTimeout(() => {
                                      setCopied(false);
                                    }, 3000);
                                  }}
                                />
                              )}
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </>
                ) : (
                  (console.log('Chat Error', chatError),
                  chatError ? (
                    <>
                      {/* <UserChatMessage message={question} image="" /> */}
                      <div className={styles.chatMessageGptMinWidth}>
                        <AnswerError
                          error={'Something went wrong. Please try again.'}
                          onRetry={() => handleSendChat(question, true)}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <Skeleton />
                    </>
                  ))
                )}
              </StyledTypography>
              {index === 0 && (streamChatLoading || projectChatLoading || fileUploadLoading) ? (
                <LinearProgress
                  sx={{
                    height: '5px',
                  }}
                />
              ) : (
                <></>
              )}
            </StyledPaper>
          ) : chatError !== undefined && chatError != '' ? (
            <div className={styles.chatMessageGptMinWidth}>
              <AnswerError
                error={'Something went wrong. Please try again.'}
                onRetry={() => handleSendChat(question, true)}
              />
            </div>
          ) : (
            <Skeleton
              sx={{
                height: '50px',
                width: '100%',
              }}
            />
          )}
        </Box>
        {/* <FeedBackPopup
                open={feedbackPopupOpen}
                onClose={handleFeedbackClose}
                onSubmit={handleFeedbackSubmit}
            /> */}
      </Box>
    );
  };

  // useEffect( () => {
  //     const synth = window.speechSynthesis;
  //     if ('speechSynthesis' in window) {
  //     if (isSpeaking) {
  //         // If already speaking, stop the speech
  //         synth.cancel();
  //         setIsSpeaking(false);
  //     }
  //     }
  // },[isSpeaking])

  const cancelSpeak = () => {
    const synth = window.speechSynthesis;
    if ('speechSynthesis' in window) {
      if (isSpeaking) {
        // If already speaking, stop the speech
        synth.cancel();
        setIsSpeaking(false);
      }
    }
  };

  const handleSpeak = (text: string) => {
    const synth = window.speechSynthesis;

    if ('speechSynthesis' in window) {
      if (isSpeaking) {
        // If already speaking, stop the speech
        synth.cancel();
        setIsSpeaking(false);
      } else {
        const utterance = new SpeechSynthesisUtterance(text);
        const voices = synth.getVoices();
        // console.log('Voices: ', voices);
        // Optionally set a specific voice
        // utterance.voice = voices[0];

        // Start speaking
        synth.speak(utterance);
        setIsSpeaking(true);

        // Listen for the end of the speech
        utterance.onend = () => {
          setIsSpeaking(false);
        };
      }
    } else {
      alert('Sorry, your browser does not support speech synthesis.');
    }
  };

  const handleModalClose = () => setModalOpen(false);

  const handleCitationClose = () => setCitationModalOpen(false);

  const tabStyle = ({ isSelected }: any) => ({
    // background: isSelected ? "rgba(222, 230, 239, 1)" : "none",
    borderRadius: '0px',
    cursor: 'pointer',
    // "&:hover": {
    //     backgroundColor: "rgba(200, 230, 239, 1)",
    // },
  });

  const SessionChatBox = ({ chat }: any) => {
    const [isSessionBoxOpen, setIsSessionBoxOpen] = useState<boolean>(false);
    return (
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        padding="10px 10px"
        key={chat.session_id}
        sx={tabStyle({
          isSelected: selectedSession === chat.session_id,
        })}
        onMouseEnter={() => {
          setIsSessionBoxOpen(true);
        }}
        onMouseLeave={() => {
          setIsSessionBoxOpen(false);
        }}
      >
        <ChatIcon fontSize="small" />
        <StyledTypography
          variant="subtitle2"
          fontWeight="400"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
            pl: '5px',
            color: theme.palette.text.primary,
          }}
          onClick={() => {
            handleSessionClick(chat.session_id);
          }}
        >
          {chat.session_name}
        </StyledTypography>
        {/* </Box> */}
        {/* {isSessionBoxOpen && <DeleteOutlinedIcon color="inherit" fontSize="small"
                    onClick={() => {
                        console.log("clicked on delete", chat.session_id);
                    }}
                />} */}
      </Box>
    );
  };

  return (
    <div className={`app-container ${loader ? 'blur' : ''}`}>
      {chatOption === 'file' ? (
        indexLoading === false &&
        indexedData &&
        Object.keys(indexedData).length !== 0 && (
          <SummaryModal
            modalOpen={modalOpen}
            handleModalClose={handleModalClose}
            chatOption={chatOption}
            modalData={{
              summary: indexedData[0][fileName[0]]?.summary,
              topics: indexedData[0][fileName[0]]?.topics,
            }}
          />
        )
      ) : (
        <></>
      )}
      <CitationsModal modalOpen={citationModalOpen} handleModalClose={handleCitationClose} citationURL={citationURL} />
      {/* {
                loader && 
                // <Modal
                //     open={loader}
                //     aria-labelledby="simple-modal-title"
                //     aria-describedby="simple-modal-description"
                // >
                //     <Spinner />
                // </Modal>
                <Spinner />

            } */}
      {loader && (
        // <div className="spinner-overlay">
        // <Spinner labelPosition="below" label="Analysing conversations" size="large"/>
        // </div>
        // <Field validationMessage="Analysing conversations" validationState="none">
        //     <ProgressBar
        //         className={progress_styles.container}
        //         thickness="large"/>
        // </Field>
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      )}
      <TranscriptSummaryModal
        modalOpen={trnscriptModalOpen}
        handleModalClose={() => setTranscriptModalOpen(false)}
        TranscriptModaldata={transcriptData}
      />
      <Grid
        sx={{
          width: '100%',
          height: `calc(100vh - 95px)`,
          borderRadius: '4px',
          mb: '10px',
          gap: '10px',
        }}
        container
        wrap="nowrap"
      >
        <GridBoxes
          item
          xs={2}
          md={2.5}
          sx={{
            // background: "rgba(255, 255, 255, 1)",
            background: theme.palette.background.paper,
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
          }}
        >
          <Box
            sx={{ height: '100%', width: '100%' }}
            display="flex"
            flexDirection={'column'}
            alignItems="center"
            justifyContent="space-between"
          >
            <Box sx={{ width: '100%', overflowY: 'auto', flex: '1 1 0%' }}>
              {chatSessionList.map((chat: any, index) => {
                return <SessionChatBox chat={chat} key={index} />;
              })}
            </Box>
            <Box width="100%" padding="15px">
              <StyledButton
                variant="contained"
                startIcon={<AddIcon />}
                size="medium"
                onClick={() => {
                  setSelectedSession(0);
                  setChatOption('none');
                  setChatHistory([]);
                }}
              >
                <Typography variant="subtitle2" fontWeight="400">
                  New AI Search
                </Typography>
              </StyledButton>
            </Box>
          </Box>
        </GridBoxes>
        <GridBoxes
          item
          xs={12}
          md={12}
          sx={{
            background: theme.palette.background.paper,
            boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
          }}
        >
          <Box sx={{ height: '93%', width: '100%' }} display="flex" flexDirection={'column'} alignItems="center">
            <Box
              sx={{ width: '100%', overflowY: 'auto' }}
              display="flex"
              flex="1 1 0%"
              flexDirection={'column'}
              alignItems="center"
              justifyContent={chatHistory.length === 0 ? 'space-between' : 'flex-start'}
              position="relative"
            >
              <Box
                position="sticky"
                width="100%"
                left="0"
                top="0"
                p={3}
                zIndex={1000}
                sx={{
                  background: theme.palette.background.paper,
                }}
                display="flex"
                justifyContent={'space-between'}
              >
                <PopperOptions
                  projectsInfo={projectsInfo}
                  projectsInfoLoading={projectsInfoLoading}
                  handleProjectsChatStream={handleProjectsChatStream}
                />
                {/* <IconButton color="primary">
                                    <Tooltip title="Analyze Conversation">
                                        <InfoIcon onClick = {()=>analyzeConversations()} />
                                    </Tooltip>
                                </IconButton> */}
              </Box>
              {sessionChatLoading ? (
                <Loader />
              ) : chatHistory.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: '1 1 0%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '20px',
                  }}
                >
                  <ChatOutlinedIcon sx={{ color: '#acacac', fontSize: '50px' }} />
                  <StyledTypography
                    variant="h4"
                    color="primary"
                    sx={
                      {
                        // marginBottom: "25%",
                      }
                    }
                  >
                    Chat with your data
                  </StyledTypography>
                  {chatOption === 'project' && project && project.Examples && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        padding: '10px',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                      }}
                    >
                      {(() => {
                        let examples = [];
                        try {
                          // Attempt to parse project.Examples as JSON
                          examples = JSON.parse(project.Examples.replaceAll("'", '"'));
                        } catch (e) {
                          console.error('Error parsing project.Examples:', e);
                          // If parsing fails, treat it as a plain string
                          examples = project.Examples.split(','); // Assuming comma-separated values
                        }

                        return examples.map((x: any, i: number) => (
                          <Card
                            key={project.ID + i}
                            sx={{
                              boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
                            }}
                          >
                            <Button
                              onClick={async () => {
                                handleSendChat(x);
                              }}
                            >
                              <Typography>{x}</Typography>
                            </Button>
                          </Card>
                        ));
                      })()}
                    </div>
                  )}
                </Box>
              ) : (
                <>
                  <ChatBox
                    ref={scrollIntoView}
                    marginTop="20px"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column-reverse',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        width: '100%',
                        mb: '20px',
                      }}
                    >
                      {followUpQuestions.length > 0 &&
                        followUpQuestions.map((question: any, index: number) => {
                          return (
                            <Card
                              key={index}
                              sx={{
                                // borderRadius: "6px",
                                boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
                              }}
                            >
                              <Button
                                sx={{
                                  borderRadius: '0px',
                                }}
                                onClick={async () => {
                                  handleSendChat(question);
                                }}
                              >
                                <Typography variant="body1">{question}</Typography>
                              </Button>
                            </Card>
                          );
                        })}
                    </Box>
                    {chatHistory.map((message: any, index: number) => {
                      return (
                        <div>
                          <ChatComponent
                            message={message}
                            index={index}
                            key={index}
                            setCitationLink={setCitationLink}
                            liked={likeDislikeStates[index]?.liked || false}
                            disliked={likeDislikeStates[index]?.disliked || false}
                            onLike={() => handleLike(index)}
                            onDislike={() => handleDislike(index, message)}
                          />
                        </div>
                      );
                    })}
                  </ChatBox>
                </>
              )}
            </Box>
            <ChatBox marginBottom="20px" height={'60px'}>
              <ThemeProvider theme={SearchBarTheme}>
                {isGeneralChat && (
                  <QuotaAlert
                    remainingTokenQuota={savedChatRes?.remaining_token_quota}
                    quotaAlert={savedChatRes?.quota_alert}
                  />
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>&nbsp;&nbsp;</div>
                <VoiceComponent
                  handleSendChat={handleSendChat}
                  selectedModel={selectedApproach}
                  onModelChange={setSelectedApproach}
                  showModelSelector={isGeneralChat}
                  userName={email}
                  showFileUpload={isGeneralChat}
                />
              </ThemeProvider>
            </ChatBox>
          </Box>
        </GridBoxes>
      </Grid>
      {<FeedBackPopup open={feedbackPopupOpen} onClose={handleFeedbackClose} onSubmit={handleFeedbackSubmit} />}
      <QuotaExceededDialog
        open={quotaExceededOpen}
        message={quotaExceededMessage}
        onClose={() => setQuotaExceededOpen(false)}
      />
      <PIIWarningDialog open={piiWarningOpen} message={piiWarningMessage} onClose={() => setPiiWarningOpen(false)} />
      <Toast ref={toast} />
    </div>
  );
};

export default KnowledgeChat;
